import { z } from 'zod';
import { Media } from '@/api';
import { makeEvent } from './EventBase';

export const MediaAddedToStorage = makeEvent(
    'MediaAddedToStorage',
    z.object({
        media: Media,
    }),
);

export type MediaAddedToStorage = (typeof MediaAddedToStorage)['schema']['_output'];
